module.exports = "<div class=modal-header> <h4 class=modal-title>{{$ctrl.messageTitle}}</h4> </div> <div class=\"modal-body background-light\"> <span ng-bind-html=$ctrl.messageTemplate></span> </div> <div class=modal-footer> <button class=\"button large alert-btn\" ng-click=$ctrl.cancel()> Close </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/appointments/appointment/read-message-templates/read-message-templates.template.html
// module id = ./components/appointments/appointment/read-message-templates/read-message-templates.template.html
// module chunks = 0